export enum RouteKeys {
  Login = '/auth/login',
  ForgotPassword = '/auth/forgot-password',
  ResetPassword = '/auth/reset-password',
}
